import { Lot, AccountCategory, ScheduleTask, Vendor, Community, ScheduleVendorAcctCategoryAssoc } from "./index";

export class MassTradePartnerPreview {
    public gridRowId: number;
    public lot: Lot;
    public community: Community;
    public accountCategoryId: number;
    public accountCategory: AccountCategory;
    public jobId: number;
    public scheduleVendorAcctCategoryAssoc: ScheduleVendorAcctCategoryAssoc;
    public oldVendorDisplayName: string;
    public scheduleTasks: ScheduleTask[];
    public vendorToUpdate: Vendor;
    public constructionStageName: string;
}